<template>
    <div id="blog">
        <div class="blogHeader">
            <h1>Blogs</h1>
        </div>
        <div class="blogPosts">
            <div 
                class="blogPost-container"
                v-for="(blog, index) in blogs" 
                :key="index"  
                
            >
                <a class="blogPost" :class="'blog' + (index + 1)"  :href="'/blog/' + blog.slug" >
                    <div class="blogImg" :style="getBackgroundImage(blog)">
                    </div>
                    <div class="blogContent">
                        <h3> {{ blog.name }} </h3>
                        <p v-html="blog.content.split(' ').slice(0, 10).join(' ') + '...'">  </p>
                        <div class="date">Published on: {{ formatDate(blog.created_at) }}</div>
                    </div>
                </a>
                <div v-if="index === 0" class="special-content">
                    <div class="plans-container">
                        <div class="plan-slider">
                            <div class="plancarousel1 owl-carousel1 owl-theme1">
                            <Plan />               
                            </div> 
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>

<script setup>

    import { ref, onMounted, computed } from 'vue'
    import axios from 'axios'
    import Plan from './Plans.vue'

    // Define a reactive reference for the blogs
    const blogs = ref([])
    const siteId = process.env.VUE_APP_SITE_ID

    // The function to load blog data
    async function loadBlogData() {
        try {
            const response = await axios.get('https://supasmart.co.uk/api/blogs/' + siteId)
            blogs.value = response.data
            const blog = response.data
        } catch (error) {
            console.error('Error loading blog data:', error)
        }
    }

    // Method to format the date into DD/MM/YYYY
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return date.toLocaleDateString('en-GB', options);
    };

    // Use the onMounted lifecycle hook to load the blog data after component mounts
    onMounted(() => {
        loadBlogData();
    });

    const getBackgroundImage = (blog) => {
        return window.innerWidth <= 640 
            ? `background-image: url(${blog.image_mobile})` 
            : `background-image: url(${blog.image_desktop})`;
    };
    
</script>


<style lang="scss" scoped>

     h1 {
        font-size: 3rem;
        font-weight: 400;
        color: var(--banana);
    }
    
    body:has(#blog, #blog-item) {
        background: #FEF9EF !important; 
    }

    .container:has(#blog, #blog-item) {
        max-width: 100% !important;
        background: #FEF9EF !important;
        margin: 0 !important;
    }

    .content:has(#blog, #blog-item) {
        display: flex;
        flex-direction: column;
        align-items: center;

        min-height: 100vh;
        padding: 0 10px;
        
    }
</style>

<style lang="scss" scoped>
    #blog {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 1200px;    
        
        .blogHeader {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 2rem 2rem 0;
            width: 100%;

            img {
                max-width: 31%;
            }
        }        

        .blogPosts {
            display: flex;
            width: 100%;
            gap: 20px;
            margin: 20px 0;
            min-height: 70vh;
            flex-wrap: wrap;

            .blogPost-container {
                display: flex;
                flex: 1 1 350px;
                flex-wrap: wrap;
                max-width: calc(33% - 10px);

                .blogPost {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                    background: white;
                    border-radius: 5px;
                    overflow: hidden;
                    border: 1px solid #cfba9c;
                    transition: all 0.2s;
                    text-decoration: none;
                    color: black;

                    .blogImg {
                        width: 100%;
                        height: 200px;
                        object-fit: cover;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: #FAEFDF;
                        background-size: cover;
                        background-position: center;

                        img {
                            width: 100%;
                        }
                    }

                    .blogContent {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        justify-content: flex-start;
                        margin: 10%;
                        gap: 10px;

                        .date {
                            font-size: 0.9rem;
                            color: #b6a078;
                        }
                    }                        

                    &:hover {
                        transform: scale(1.02);
                    }
                }

                &:first-child {
                    flex: 1 1 100%;
                    flex-direction: row;
                    max-width: 100%;

                    .blogPost {
                        flex-direction: row;
                    }

                    .blogImg {
                        width: 50%;
                        border-bottom: 0;
                        height: 100%;
                    }

                    .blogContent {
                        margin: 5%;
                        width: calc(50% - 10%);
                    }
                }

                .special-content {
                    flex: 100%;
                    width: 100%;
                    padding: 2rem 0;
                }
            }
        }
    }

    @media (max-width: 840px) {

        #blog .blogPosts .blogPost .blogContent {
            margin: 7% 5%;
        }

        #blog .blogPosts .blogPost-container:not(:first-child) {
            max-width: calc(50% - 10px);
        }
    }

    @media (max-width: 640px) {

        #blog .blogPosts .blogPost-container {
            max-width: 100% !important;

            .blogPost {
                flex-direction: column !important;
            }

            .blogImg {
                width: 100% !important;
                border-bottom: 0 !important;
                height: 200px !important;
            }

            .blogContent {
                margin: 7% 5% !important;
                width: auto !important;
            }
        }
    }
</style>